import { WarningIcon as _WarningIcon } from "$components/icons";
import { Box, styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Wrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.warning.light,
  borderRadius: theme.spacing(),
  padding: theme.spacing(),
  marginBottom: theme.spacing(2),
}));

const WarningIcon = styled(_WarningIcon)(({ theme }) => ({
  marginRight: theme.spacing(),
}));

const WarningHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(),
  fontWeight: 500,
}));

export const RegisterDownloadWarning = () => {
  return (
    <>
      <Wrapper>
        <WarningHeader display="flex">
          <WarningIcon viewBox="0 0 32 32" />
          <Typography variant="h5" display="inline">
            <FormattedMessage
              id="register.download.warn.title"
              defaultMessage="WARNING"
            />
          </Typography>
        </WarningHeader>
        <FormattedMessage
          id="register.download.warn.message"
          defaultMessage="You are requesting to download sensitive patient data. Please consider the privacy of the data subjects. You are responsible for the security of all the downloaded patient data. Elephant is not responsible for the security of patient data downloaded from ElephantOS"
        />
      </Wrapper>
      <Box mb={2}>
        <Typography variant="subtitle2" display="inline">
          <FormattedMessage
            id="register.download.info.fileProtection"
            defaultMessage="The file you download will be password protected. Once the file has downloaded a popup will appear with the password. Please ensure that you store the password in a secure place."
          />
        </Typography>
      </Box>
    </>
  );
};
